module.exports = __webpack_public_path__ + "media/images/partner/pic_5-aab9d8899397311dda8ad15969d38286.png";